import { ApiAward } from "@/api/award";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

const useAwardsData = () => {
  const { data: awards, isLoading } = useLocalizedQuery({
    queryKey: ["awards"],
    queryFn: lang => ApiAward.getAwards(lang),
  });

  return { awards, isLoading };
};

export default useAwardsData;
